import React, { useEffect, useState } from 'react';

const AccordionItem = ({ title, content, isOpen, onClick, isGiftCertificate }) => (
  isGiftCertificate == true ?
    <div className="panel panel-default giftCertificateAccordion">
      <div className="panel-heading">
        <h4 className="panel-title">
          {title}
          {/* {title} <span className="pull-right">{isOpen ? <i className="glyphicon glyphicon-chevron-up"></i> : <i className="glyphicon glyphicon-chevron-down"></i>}</span> */}
        </h4>
      </div>
      {/* {isOpen && (
        <div className="panel-collapse">
          <div className="panel-body panelBody-bottom">
            {content}
          </div>
        </div>
      )} */}
    </div>
    :
    <div className="panel panel-default giftProductsAccordion">
      <div className="panel-heading" onClick={onClick} style={{ cursor: 'pointer' }}>
        <h4 className="panel-title filter-panel-title">
          {title} <span className="pull-right">{isOpen ? <i className="glyphicon glyphicon-chevron-up"></i> : <i className="glyphicon glyphicon-chevron-down"></i>}</span>
        </h4>
      </div>
      {isOpen && (
        <div className="panel-collapse">
          <div className="panel-body panelBody-bottom">
            {content}
          </div>
        </div>
      )}
    </div>
);

const Accordion = ({ items,alwaysOpen, isOpenFilter= false }) => {
  const [openIndexes, setOpenIndexes] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const toggle = (index) => {
    if(isOpenFilter) {
      setOpenIndexes((prev) =>
        prev.includes(index)
          ? prev.filter((i) => i !== index) 
          : [...prev, index] 
      );
    } else {
      setOpenIndex(index === openIndex ? null : index);
    }
    
  };

  useEffect(()=>{
    if(isOpenFilter) {
      if (alwaysOpen === 0 && openIndexes.length === 0) {
        setOpenIndexes([0]);
      }
    } else
      if (alwaysOpen == 0 && openIndex == null) {
        setOpenIndex(0);
    }
  },[])

  return (
    <div className="panel-group accordian-wrap" id="accordion">
      {items.map((item, index) => (
        <AccordionItem
          key={index}
          title={item.title}
          content={item.content}
          isOpen={isOpenFilter ? openIndexes.includes(index) : openIndex === index}
          onClick={() => toggle(index)}
          isGiftCertificate={item.isGiftCertificate}
        />
      ))}
    </div>
  );
};

export default Accordion;
